import { Component, OnInit, OnDestroy } from '@angular/core';
import { PageComponent } from '@icc/configurator/shared';
import { _, SharedFacade } from '@icc/configurator/shared';
import { iccListItem } from '@icc/configurator/ui';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { EventBusService } from '@icc/shared';
import { MosquitoScreenFacade } from '../+state/mosquito-screen.facade';
import { TypesService } from '../types.service';

@Component({
    selector: 'icc-types-list-page',
    templateUrl: './types-list-page.component.html',
    styleUrls: ['./types-list-page.component.scss'],
    standalone: false
})
export class TypesListPageComponent extends PageComponent implements OnInit, OnDestroy {
    public title = _('MOSQUITO|Wybierz typ');

    types: iccListItem[] = [];
    selectedType$ = this.mosquitoScreenFacade.selectedType$.pipe(map(type => type.id));
    private subscriptions: Subscription[] = [];

    constructor(
        private typesService: TypesService,
        private eventBusService: EventBusService,
        private mosquitoScreenFacade: MosquitoScreenFacade,
        private sharedFacade: SharedFacade
    ) {
        super();
        if (this.typesService.loadedData) {
            this.init();
        }
        this.subscriptions.push(
            this.eventBusService.subscribeWithoutConfiguration('initializedConfigurator', () =>
                this.init()
            )
        );
    }

    ngOnInit() {}

    ngOnDestroy() {
        this.subscriptions.map(el => el.unsubscribe());
    }

    init() {
        this.types = this.typesService.types.map(type => ({
            id: type.id,
            title: type.name,
            tabs: [type.type],
            imageUrl: '/files/mosquitotype/' + type.img,
        }));
    }

    selectType(item: iccListItem) {
        const type = this.typesService.types.find(s => s.id === item.id);
        if (type) {
            this.typesService.selectType(type, true);
            this.sharedFacade.closePage();
        }
    }
}
